// extracted by mini-css-extract-plugin
module.exports = {"ratios":"_2voPcSh"};